var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardrivingRafiki2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tree--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.44,200a7.72,7.72,0,0,0-4.32-1.31c-.88-1.19,0-2.87.93-4s2.15-2.4,1.87-3.86c-.41-2.19-3.45-2.42-5.66-2.1-.75-1.36-.65-3-1-4.51s-1.44-3.13-3-3-2.41,1.69-3.84,2c-1.66.3-3-1.22-4.25-2.37a5,5,0,0,0-.49-.4h0c.49-4.49,4.75-3.56,8.44-4,2.88-.34-4.33-7.92,1.54-10a5.11,5.11,0,0,0,2.88-1.81,3.27,3.27,0,0,0-1.06-4,7.78,7.78,0,0,0-4.33-1.31c-.88-1.19,0-2.87.93-4s2.15-2.4,1.87-3.86c-.41-2.19-3.44-2.42-5.66-2.1-.75-1.36-.65-3-1-4.51s-1.43-3.13-3-3-2.41,1.69-3.85,2c-1.66.3-3-1.22-4.25-2.37s-3.45-1.94-4.41-.55c-.57.83-.31,2-.91,2.87-1,1.42-3.25.4-4.61-.71s-3.56-2.16-4.62-.76a6.09,6.09,0,0,0-.62,1.48,4.31,4.31,0,0,1-.61,1c-.23-1-.26-2.11-.48-3.14-.32-1.51-1.43-3.14-3-3s-2.42,1.69-3.85,1.95c-1.66.31-3-1.21-4.25-2.36s-3.45-2-4.41-.55c-.58.83-.32,2-.91,2.86a1.57,1.57,0,0,1-.48.45c-.48-.08-1-.13-1.45-.17-.89-1.18,0-2.87.93-4s2.14-2.4,1.86-3.85c-.41-2.2-3.44-2.42-5.66-2.11-.74-1.35-.65-3-1-4.5s-1.43-3.14-3-3-2.41,1.69-3.84,2c-1.67.31-3-1.21-4.25-2.36s-3.46-2-4.42-.55c-.57.83-.31,2-.9,2.86-1,1.42-3.26.4-4.62-.71s-3.56-2.16-4.62-.76a6.26,6.26,0,0,0-.62,1.48c-.76,1.89-2.88,2.75-4.56,3.91s-3.09,3.54-1.79,5.11c.64.78,1.82,1.14,2.11,2.1.36,1.21-.9,2.21-1.9,3a5.05,5.05,0,0,0-1.19,5.11,4.43,4.43,0,0,1-1.72.89c-1.66.3-3-1.22-4.25-2.37s-3.45-1.94-4.41-.55c-.57.83-.31,2.05-.91,2.87-1,1.42-3.25.4-4.61-.71s-3.56-2.16-4.62-.77a6,6,0,0,0-.62,1.48c-.76,1.9-2.89,2.75-4.57,3.91s-3.08,3.55-1.78,5.12c.61.74,1.71,1.11,2.06,2-1.12-.5-2.35-.58-3,.37s-.32,2-.91,2.87c-1,1.42-3.26.4-4.61-.71s-3.56-2.16-4.62-.76a5.72,5.72,0,0,0-.62,1.48c-.76,1.89-2.89,2.74-4.57,3.9s-3.08,3.55-1.78,5.12c.64.78,1.81,1.13,2.1,2.1.36,1.2-.9,2.2-1.89,3-1.66,1.28-2.15,5.31-.09,6.52.86.51,2.15.72,2.32,1.7s-.77,1.52-1.39,2.16a4.18,4.18,0,0,0,1,6.29c.49.27,1.1.5,1.26,1a2,2,0,0,1-.17,1.17,6.3,6.3,0,0,0-.32,2.24,1,1,0,0,0,.24.72,1.12,1.12,0,0,0,.66.23c3,.28,4.55-.73,6.28,2a2.26,2.26,0,0,0,.6.7,2,2,0,0,0,.83.25c2.08.27,3.51-1,5.43-1.11,2.67-.21,3.16,1.18,5.44,2.39,3.59,1.91,5.42.93,6.23-1.54a10.59,10.59,0,0,0,.44-2.15,3.77,3.77,0,0,1,1.41-2.82h.07c1.94.25,3.31-.79,5-1.06l1.08-.06c2.06.08,2.68,1.31,4.74,2.4a7.4,7.4,0,0,0,3.1,1c.25,1.15-1,2.11-1.91,2.86-1.66,1.27-2.15,5.31-.09,6.52.86.51,2.15.71,2.32,1.7s-.77,1.52-1.39,2.16a4.19,4.19,0,0,0,1,6.29c.49.27,1.1.5,1.26,1a2,2,0,0,1-.17,1.17,6.36,6.36,0,0,0-.32,2.25.81.81,0,0,0,.9.94c3,.28,4.55-.72,6.28,2a2.19,2.19,0,0,0,.6.71,2,2,0,0,0,.83.25c2.08.27,3.51-1,5.43-1.12,2.67-.21,3.16,1.19,5.44,2.4,3.59,1.9,5.42.92,6.23-1.54a10.69,10.69,0,0,0,.44-2.16c.48-4.49,4.75-3.57,8.44-4a.73.73,0,0,0,.62-.38l.23,0c2.08.27,3.51-1,5.43-1.12,2.66-.21,3.16,1.19,5.44,2.4,3.59,1.9,5.42.93,6.23-1.54a10.07,10.07,0,0,0,.43-2.16c.38-3.49,3.05-3.71,6-3.84a4,4,0,0,0,2,3.38c.49.27,1.1.5,1.27,1a2.1,2.1,0,0,1-.18,1.17,6.08,6.08,0,0,0-.31,2.24.81.81,0,0,0,.89.94c3,.29,4.56-.72,6.28,2a2.26,2.26,0,0,0,.6.7,2,2,0,0,0,.83.25c2.08.27,3.51-1,5.43-1.11,2.67-.21,3.16,1.18,5.45,2.39,3.58,1.91,5.42.93,6.23-1.54a11.3,11.3,0,0,0,.43-2.16c.49-4.49,4.75-3.56,8.44-4,2.88-.34-4.34-7.92,1.54-10A5,5,0,0,0,223.5,204,3.26,3.26,0,0,0,222.44,200Zm-38.9,4.6a1.32,1.32,0,0,1,.6.84,1.19,1.19,0,0,1-.15.79A12.37,12.37,0,0,1,183.54,204.59ZM146,165.2a5.82,5.82,0,0,1-2.9-1.82A17.06,17.06,0,0,1,146,165.2ZM175.67,176a3.47,3.47,0,0,1,.7-1.21,1.35,1.35,0,0,1,.71.74,1,1,0,0,1,0,.3,1.88,1.88,0,0,0-.63-.06A2.34,2.34,0,0,0,175.67,176Zm4,3.93c1.71,0,2.86,0,4.13,2a2.13,2.13,0,0,0,.6.7,2,2,0,0,0,.82.25,6.4,6.4,0,0,0,3.15-.53c-.1.28-.18.57-.29.85a5.08,5.08,0,0,1-2,2.23h0c-.41-2.2-3.44-2.42-5.66-2.11A9.19,9.19,0,0,1,179.64,179.88Zm13.65,2.52a7.67,7.67,0,0,0-.62-.46,13.53,13.53,0,0,1,2.44,1.56A7.54,7.54,0,0,1,193.29,182.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.88,239.8a6.14,6.14,0,0,0-3.41-1c-.69-.94,0-2.26.73-3.14s1.69-1.89,1.48-3c-.33-1.73-2.72-1.91-4.46-1.66-.59-1.06-.51-2.35-.77-3.54s-1.12-2.47-2.34-2.38-1.9,1.33-3,1.54c-1.31.24-2.38-1-3.35-1.87s-2.72-1.52-3.47-.43c-.46.66-.25,1.61-.72,2.26-.81,1.12-2.56.31-3.63-.56s-2.8-1.7-3.64-.6a4.67,4.67,0,0,0-.49,1.17c-.6,1.48-2.27,2.16-3.59,3.07s-2.43,2.79-1.41,4c.51.61,1.43.89,1.66,1.65.29.95-.71,1.74-1.49,2.34-1.31,1-1.69,4.19-.07,5.14.67.4,1.69.56,1.82,1.34s-.6,1.19-1.09,1.7a3.3,3.3,0,0,0,.77,5c.39.21.87.39,1,.82a1.57,1.57,0,0,1-.14.92,5.06,5.06,0,0,0-.25,1.77.8.8,0,0,0,.19.56.88.88,0,0,0,.52.18c2.39.22,3.59-.57,4.94,1.58a1.86,1.86,0,0,0,.48.56,1.58,1.58,0,0,0,.65.19c1.64.22,2.76-.76,4.28-.88,2.1-.16,2.49.94,4.28,1.89,2.83,1.5,4.27.73,4.91-1.21a8.81,8.81,0,0,0,.34-1.7c.38-3.54,3.74-2.81,6.65-3.15,2.26-.27-3.42-6.24,1.21-7.85a4,4,0,0,0,2.26-1.42A2.59,2.59,0,0,0,112.88,239.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.44,200a7.72,7.72,0,0,0-4.32-1.31c-.88-1.19,0-2.87.93-4s2.15-2.4,1.87-3.86c-.41-2.19-3.45-2.42-5.66-2.1-.75-1.36-.65-3-1-4.51s-1.44-3.13-3-3-2.41,1.69-3.84,2c-1.66.3-3-1.22-4.25-2.37a5,5,0,0,0-.49-.4h0c.49-4.49,4.75-3.56,8.44-4,2.88-.34-4.33-7.92,1.54-10a5.11,5.11,0,0,0,2.88-1.81,3.27,3.27,0,0,0-1.06-4,7.78,7.78,0,0,0-4.33-1.31c-.88-1.19,0-2.87.93-4s2.15-2.4,1.87-3.86c-.41-2.19-3.44-2.42-5.66-2.1-.75-1.36-.65-3-1-4.51s-1.43-3.13-3-3-2.41,1.69-3.85,2c-1.66.3-3-1.22-4.25-2.37s-3.45-1.94-4.41-.55c-.57.83-.31,2-.91,2.87-1,1.42-3.25.4-4.61-.71s-3.56-2.16-4.62-.76a6.09,6.09,0,0,0-.62,1.48,4.31,4.31,0,0,1-.61,1c-.23-1-.26-2.11-.48-3.14-.32-1.51-1.43-3.14-3-3s-2.42,1.69-3.85,1.95c-1.66.31-3-1.21-4.25-2.36s-3.45-2-4.41-.55c-.58.83-.32,2-.91,2.86a1.57,1.57,0,0,1-.48.45c-.48-.08-1-.13-1.45-.17-.89-1.18,0-2.87.93-4s2.14-2.4,1.86-3.85c-.41-2.2-3.44-2.42-5.66-2.11-.74-1.35-.65-3-1-4.5s-1.43-3.14-3-3-2.41,1.69-3.84,2c-1.67.31-3-1.21-4.25-2.36s-3.46-2-4.42-.55c-.57.83-.31,2-.9,2.86-1,1.42-3.26.4-4.62-.71s-3.56-2.16-4.62-.76a6.26,6.26,0,0,0-.62,1.48c-.76,1.89-2.88,2.75-4.56,3.91s-3.09,3.54-1.79,5.11c.64.78,1.82,1.14,2.11,2.1.36,1.21-.9,2.21-1.9,3a5.05,5.05,0,0,0-1.19,5.11,4.43,4.43,0,0,1-1.72.89c-1.66.3-3-1.22-4.25-2.37s-3.45-1.94-4.41-.55c-.57.83-.31,2.05-.91,2.87-1,1.42-3.25.4-4.61-.71s-3.56-2.16-4.62-.77a6,6,0,0,0-.62,1.48c-.76,1.9-2.89,2.75-4.57,3.91s-3.08,3.55-1.78,5.12c.61.74,1.71,1.11,2.06,2-1.12-.5-2.35-.58-3,.37s-.32,2-.91,2.87c-1,1.42-3.26.4-4.61-.71s-3.56-2.16-4.62-.76a5.72,5.72,0,0,0-.62,1.48c-.76,1.89-2.89,2.74-4.57,3.9s-3.08,3.55-1.78,5.12c.64.78,1.81,1.13,2.1,2.1.36,1.2-.9,2.2-1.89,3-1.66,1.28-2.15,5.31-.09,6.52.86.51,2.15.72,2.32,1.7s-.77,1.52-1.39,2.16a4.18,4.18,0,0,0,1,6.29c.49.27,1.1.5,1.26,1a2,2,0,0,1-.17,1.17,6.3,6.3,0,0,0-.32,2.24,1,1,0,0,0,.24.72,1.12,1.12,0,0,0,.66.23c3,.28,4.55-.73,6.28,2a2.26,2.26,0,0,0,.6.7,2,2,0,0,0,.83.25c2.08.27,3.51-1,5.43-1.11,2.67-.21,3.16,1.18,5.44,2.39,3.59,1.91,5.42.93,6.23-1.54a10.59,10.59,0,0,0,.44-2.15,3.77,3.77,0,0,1,1.41-2.82h.07c1.94.25,3.31-.79,5-1.06l1.08-.06c2.06.08,2.68,1.31,4.74,2.4a7.4,7.4,0,0,0,3.1,1c.25,1.15-1,2.11-1.91,2.86-1.66,1.27-2.15,5.31-.09,6.52.86.51,2.15.71,2.32,1.7s-.77,1.52-1.39,2.16a4.19,4.19,0,0,0,1,6.29c.49.27,1.1.5,1.26,1a2,2,0,0,1-.17,1.17,6.36,6.36,0,0,0-.32,2.25.81.81,0,0,0,.9.94c3,.28,4.55-.72,6.28,2a2.19,2.19,0,0,0,.6.71,2,2,0,0,0,.83.25c2.08.27,3.51-1,5.43-1.12,2.67-.21,3.16,1.19,5.44,2.4,3.59,1.9,5.42.92,6.23-1.54a10.69,10.69,0,0,0,.44-2.16c.48-4.49,4.75-3.57,8.44-4a.73.73,0,0,0,.62-.38l.23,0c2.08.27,3.51-1,5.43-1.12,2.66-.21,3.16,1.19,5.44,2.4,3.59,1.9,5.42.93,6.23-1.54a10.07,10.07,0,0,0,.43-2.16c.38-3.49,3.05-3.71,6-3.84a4,4,0,0,0,2,3.38c.49.27,1.1.5,1.27,1a2.1,2.1,0,0,1-.18,1.17,6.08,6.08,0,0,0-.31,2.24.81.81,0,0,0,.89.94c3,.29,4.56-.72,6.28,2a2.26,2.26,0,0,0,.6.7,2,2,0,0,0,.83.25c2.08.27,3.51-1,5.43-1.11,2.67-.21,3.16,1.18,5.45,2.39,3.58,1.91,5.42.93,6.23-1.54a11.3,11.3,0,0,0,.43-2.16c.49-4.49,4.75-3.56,8.44-4,2.88-.34-4.34-7.92,1.54-10A5,5,0,0,0,223.5,204,3.26,3.26,0,0,0,222.44,200Zm-38.9,4.6a1.32,1.32,0,0,1,.6.84,1.19,1.19,0,0,1-.15.79A12.37,12.37,0,0,1,183.54,204.59ZM146,165.2a5.82,5.82,0,0,1-2.9-1.82A17.06,17.06,0,0,1,146,165.2ZM175.67,176a3.47,3.47,0,0,1,.7-1.21,1.35,1.35,0,0,1,.71.74,1,1,0,0,1,0,.3,1.88,1.88,0,0,0-.63-.06A2.34,2.34,0,0,0,175.67,176Zm4,3.93c1.71,0,2.86,0,4.13,2a2.13,2.13,0,0,0,.6.7,2,2,0,0,0,.82.25,6.4,6.4,0,0,0,3.15-.53c-.1.28-.18.57-.29.85a5.08,5.08,0,0,1-2,2.23h0c-.41-2.2-3.44-2.42-5.66-2.11A9.19,9.19,0,0,1,179.64,179.88Zm13.65,2.52a7.67,7.67,0,0,0-.62-.46,13.53,13.53,0,0,1,2.44,1.56A7.54,7.54,0,0,1,193.29,182.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.88,239.8a6.14,6.14,0,0,0-3.41-1c-.69-.94,0-2.26.73-3.14s1.69-1.89,1.48-3c-.33-1.73-2.72-1.91-4.46-1.66-.59-1.06-.51-2.35-.77-3.54s-1.12-2.47-2.34-2.38-1.9,1.33-3,1.54c-1.31.24-2.38-1-3.35-1.87s-2.72-1.52-3.47-.43c-.46.66-.25,1.61-.72,2.26-.81,1.12-2.56.31-3.63-.56s-2.8-1.7-3.64-.6a4.67,4.67,0,0,0-.49,1.17c-.6,1.48-2.27,2.16-3.59,3.07s-2.43,2.79-1.41,4c.51.61,1.43.89,1.66,1.65.29.95-.71,1.74-1.49,2.34-1.31,1-1.69,4.19-.07,5.14.67.4,1.69.56,1.82,1.34s-.6,1.19-1.09,1.7a3.3,3.3,0,0,0,.77,5c.39.21.87.39,1,.82a1.57,1.57,0,0,1-.14.92,5.06,5.06,0,0,0-.25,1.77.8.8,0,0,0,.19.56.88.88,0,0,0,.52.18c2.39.22,3.59-.57,4.94,1.58a1.86,1.86,0,0,0,.48.56,1.58,1.58,0,0,0,.65.19c1.64.22,2.76-.76,4.28-.88,2.1-.16,2.49.94,4.28,1.89,2.83,1.5,4.27.73,4.91-1.21a8.81,8.81,0,0,0,.34-1.7c.38-3.54,3.74-2.81,6.65-3.15,2.26-.27-3.42-6.24,1.21-7.85a4,4,0,0,0,2.26-1.42A2.59,2.59,0,0,0,112.88,239.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.58,218.55,183,203.82l9.76-11.35-1.51-1.39-9.12,9-.81-15-3.45-.17s3.73,17.31.43,23.68c0,0-13.68,27.41-20.53,33a6.12,6.12,0,0,0-1,1.12,68.33,68.33,0,0,0-6.91-14.64c2.91-6.5,9.16-20.82,11.43-28.48a154.5,154.5,0,0,0,4.22-18.2L163,179.88s-7.12,29.66-17.82,42.26a40.09,40.09,0,0,0-9.71-7.2c-.61-4.08-.62-11.13,2.59-22l-1.9-1.93s-4.72,10.42-4.91,21.55a37.4,37.4,0,0,1-4.24-2.8c-9.37-7.29-15.59-19.95-15.59-19.95l-3.68-.18s9,20.59,20.24,27.23,18,21.79,18.4,25.7c.12,1.12-.2,12.83-.7,29-12.24-8.25-42.32-28.59-43.87-30l-.18,3.75L145.37,281c-1.21,37.57-3.1,90.24-3.41,98.69l17.87.87c.77-11.65,5-79.73,1.13-117.24.23-1.12.48-2.4.75-3.89,2.46-14,16.61-34.57,19.4-37.85S192,207.94,192,207.94l-1.45-2.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.58,218.55,183,203.82l9.76-11.35-1.51-1.39-9.12,9-.81-15-3.45-.17s3.73,17.31.43,23.68c0,0-13.68,27.41-20.53,33a6.12,6.12,0,0,0-1,1.12,68.33,68.33,0,0,0-6.91-14.64c2.91-6.5,9.16-20.82,11.43-28.48a154.5,154.5,0,0,0,4.22-18.2L163,179.88s-7.12,29.66-17.82,42.26a40.09,40.09,0,0,0-9.71-7.2c-.61-4.08-.62-11.13,2.59-22l-1.9-1.93s-4.72,10.42-4.91,21.55a37.4,37.4,0,0,1-4.24-2.8c-9.37-7.29-15.59-19.95-15.59-19.95l-3.68-.18s9,20.59,20.24,27.23,18,21.79,18.4,25.7c.12,1.12-.2,12.83-.7,29-12.24-8.25-42.32-28.59-43.87-30l-.18,3.75L145.37,281c-1.21,37.57-3.1,90.24-3.41,98.69l17.87.87c.77-11.65,5-79.73,1.13-117.24.23-1.12.48-2.4.75-3.89,2.46-14,16.61-34.57,19.4-37.85S192,207.94,192,207.94l-1.45-2.44Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.19,382.24s-2.6-8.72,2.67-10.46,8.39-5.81,8.21-10.43,5.37-9.1,9.52-4.77,3.6-3.33,9.15-5.19,10.24,2.65,8.72,6.77,4,6.7,10.5,3.19,13.76,2.87,12.37,7.86-.25,5.54,3.89,3.88,11.56,3.05,9,9.15S365.19,382.24,365.19,382.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.11,383.16c-4.67-3.17-.47-8.56,4.21-9.2s9.37-6.21,9.59-9.76,8.64-14.48,21.73-7.73,9.11,1,18.58-.9,15.44,3.56,11.29,7.65c0,0,9.51-1.62,13.43,4.4s0,9.77,0,9.77,17.89-.36,16.28,7.14S92.11,383.16,92.11,383.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74,379.43s8.49-16.55,6.35-18.17-6.34,13.83-6.35,12.62.24-22.25-3.68-21.41,0,20.21,0,20.21-5.27-9.9-7.34-9.15,6.1,12.52,6.1,12.52-4.88-2.94-6.1-2.72,6.1,6.1,6.1,6.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.5,381.45s-8.49-16.56-6.35-18.18,6.34,13.83,6.35,12.63-.24-22.25,3.68-21.41,0,20.21,0,20.21,5.27-9.9,7.34-9.15-6.1,12.52-6.1,12.52,4.88-2.95,6.1-2.72-6.1,6.1-6.1,6.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.19,382.24s-2.6-8.72,2.67-10.46,8.39-5.81,8.21-10.43,5.37-9.1,9.52-4.77,3.6-3.33,9.15-5.19,10.24,2.65,8.72,6.77,4,6.7,10.5,3.19,13.76,2.87,12.37,7.86-.25,5.54,3.89,3.88,11.56,3.05,9,9.15S365.19,382.24,365.19,382.24Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.11,383.16c-4.67-3.17-.47-8.56,4.21-9.2s9.37-6.21,9.59-9.76,8.64-14.48,21.73-7.73,9.11,1,18.58-.9,15.44,3.56,11.29,7.65c0,0,9.51-1.62,13.43,4.4s0,9.77,0,9.77,17.89-.36,16.28,7.14S92.11,383.16,92.11,383.16Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74,379.43s8.49-16.55,6.35-18.17-6.34,13.83-6.35,12.62.24-22.25-3.68-21.41,0,20.21,0,20.21-5.27-9.9-7.34-9.15,6.1,12.52,6.1,12.52-4.88-2.94-6.1-2.72,6.1,6.1,6.1,6.1Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.5,381.45s-8.49-16.56-6.35-18.18,6.34,13.83,6.35,12.63-.24-22.25,3.68-21.41,0,20.21,0,20.21,5.27-9.9,7.34-9.15-6.1,12.52-6.1,12.52,4.88-2.95,6.1-2.72-6.1,6.1-6.1,6.1Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.78,380.92s9.65-8.49,6.76-9.93-6.4,6.42-6.76,5.24,1.89-12-3.46-11.22,0,11.22,0,11.22-4-4.3-5.36-3.62,4.22,8.31,4.22,8.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.78,380.92s9.65-8.49,6.76-9.93-6.4,6.42-6.76,5.24,1.89-12-3.46-11.22,0,11.22,0,11.22-4-4.3-5.36-3.62,4.22,8.31,4.22,8.31Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51,378.11H446.59a2,2,0,0,1,2,2v18.26a0,0,0,0,1,0,0H49a0,0,0,0,1,0,0V380.13A2,2,0,0,1,51,378.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,378.11H446.59a2,2,0,0,1,2,2v18.26a0,0,0,0,1,0,0H49a0,0,0,0,1,0,0V380.13A2,2,0,0,1,51,378.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.48,
    y: 382.17,
    width: 26.17,
    height: 13.74,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.91,
    y: 380.86,
    width: 26.17,
    height: 13.74,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.76,
    y: 385.86,
    width: 17.03,
    height: 8.74,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.46,
    y: 386.99,
    width: 17.03,
    height: 8.74,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.48,
    y: 381.5,
    width: 17.91,
    height: 11.96,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.98,
    y: 379.88,
    width: 12.19,
    height: 11.96,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.46,
    y: 382.17,
    width: 12.19,
    height: 11.96,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.64,
    y: 382.17,
    width: 12.19,
    height: 11.96,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.43,
    y: 379.88,
    width: 12.19,
    height: 8.27,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.67,
    y: 383.06,
    width: 20.06,
    height: 11.96,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.19,
    y: 381.5,
    width: 20.06,
    height: 11.96,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.69,
    y: 380.86,
    width: 12.92,
    height: 3.85,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.46,
    y: 381.13,
    width: 12.92,
    height: 3.85,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.4,
    y: 389.92,
    width: 12.92,
    height: 3.85,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.25,
    y: 382.17,
    width: 26.17,
    height: 13.74,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.68,
    y: 380.86,
    width: 26.17,
    height: 13.74,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.53,
    y: 385.86,
    width: 17.03,
    height: 8.74,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.26,
    y: 381.5,
    width: 17.91,
    height: 11.96,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.76,
    y: 379.88,
    width: 12.19,
    height: 11.96,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.41,
    y: 382.17,
    width: 12.19,
    height: 11.96,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.21,
    y: 379.88,
    width: 12.19,
    height: 8.27,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.45,
    y: 383.06,
    width: 20.06,
    height: 11.96,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.97,
    y: 381.5,
    width: 20.06,
    height: 11.96,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.46,
    y: 380.86,
    width: 12.92,
    height: 3.85,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.17,
    y: 389.92,
    width: 12.92,
    height: 3.85,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Birds--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.71,
    y: 359.55,
    width: 31.65,
    height: 15.56,
    rx: 1.78,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.32,119.32s.45-5.06,1.64-5.85,8.47-2.71,8.47-2.71-2.88,7.8-4.63,8.7S375.32,119.32,375.32,119.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.43,110.76h0c-.09.24-2.91,7.82-4.63,8.7a6.8,6.8,0,0,1-3.59.24,16.57,16.57,0,0,1-1.89-.38s.46-5.07,1.64-5.85,7.8-2.54,8.43-2.7h0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.43,110.76c-.09.24-2.91,7.82-4.63,8.7a6.8,6.8,0,0,1-3.59.24c-1.67-1.12,1.85-2.34,2.38-2.73s.19-.79,0-1.08.46-1,1.19-1.24,1-.84.79-1.69,3.35-2,3.8-2.19h0Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.61,116.28c1.65,0,5.41,1.8,6.65,1.89s7.4-4.15,8.72-4.85,12.93-2.26,12.93-2.26-7.7,7.88-12.93,8.11c0,0,3.87,1.08,5,.79a51.58,51.58,0,0,1,10.89-1.06l-7.16,2.33L402,122a31.94,31.94,0,0,1-8.82.33,44,44,0,0,1-6.91,1.91,11,11,0,0,1-9.43-1.93c-2.26-1.83-9.71-3.9-9.71-3.9l2.54-.9A2.23,2.23,0,0,1,371.61,116.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.71,121.23,402,122a32,32,0,0,1-8.83.33,38.85,38.85,0,0,1-5.55,1.61l-1.35.3a11,11,0,0,1-9.43-1.93,18.38,18.38,0,0,0-4.47-2.19l-.84-.31h0l-.63-.22-1.34-.44c-1.4-.45-2.43-.74-2.43-.74l2.54-.91a2.23,2.23,0,0,1,2-1.26,17.69,17.69,0,0,1,4.67,1.32,9.27,9.27,0,0,0,2,.57c1.24.1,7.4-4.15,8.72-4.85a42.2,42.2,0,0,1,6.65-1.34c3.18-.5,6.28-.92,6.28-.92s-5.33,5.46-10.14,7.42a9.2,9.2,0,0,1-2.48.67h0l-.3,0,.06,0c.5.13,3.9,1,4.94.77.8-.2,1.65-.37,2.52-.5h0a58.12,58.12,0,0,1,8.35-.56Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.28,117.6a3.65,3.65,0,0,0-2.21.5c-.5.52-.95,1.63-1.75,2.06l-.84-.31h0l-.63-.22-1.34-.44a5.18,5.18,0,0,1,.11-1.65,2.23,2.23,0,0,1,2-1.26A17.69,17.69,0,0,1,376.28,117.6Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.91,111.06s-5.33,5.46-10.14,7.42a15.84,15.84,0,0,1-2.48.67h0l-.24,0c-3.89.6-4.34,0-4.34,0s1.32-.38,1.45-.38-.55-.43.29-.75.72-.74.72-.74a12,12,0,0,0,2.42-1c.08-.26-.3-.68.76-.89s0-.77,1.69-1.36,1.23-.93,1.23-.93a4.58,4.58,0,0,0,2.37-1.12C396.81,111.48,399.91,111.06,399.91,111.06Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.71,121.23,402,122a32,32,0,0,1-8.83.33,38.85,38.85,0,0,1-5.55,1.61c-.72-.38,1.32-1,2.21-1.48,1.14-.59,1-.46.55-.76s0-.38,1.36-.68,1-.59,1.82-1.2a3.13,3.13,0,0,1,1-.4h0a58.12,58.12,0,0,1,8.35-.56Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.62 117.54 370.34 118.06 369.91 119.32 367.08 118.45 369.62 117.54",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.47,171.09c1.1-.69,5.63,4.19,7.77,4.8a7.52,7.52,0,0,1-4.71.06C290.17,175.12,288.31,171.81,289.47,171.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.24,175.89a7.64,7.64,0,0,1-4.71.07c-2.36-.83-4.22-4.15-3.06-4.87.26-.17.71,0,1.28.31C292.58,172.47,295.61,175.42,297.24,175.89Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.24,175.89s-1.93.21-2.2-.08a1.34,1.34,0,0,0-1.08-.43c-.54,0-.75-.27-.65-.81s-.68-.25-1.13-.43.05-.35.06-.73-.92-.42-1-.73.31-.23.11-.55-.87-.43-.63-.73C292.58,172.47,295.61,175.42,297.24,175.89Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.9,170.15c1.11-.25,3.88.52,4.73.43s6-.44,6-.44a12.42,12.42,0,0,0,3.47-.11,35.32,35.32,0,0,1,7.2-2.1l-4.53,2.48,4.31-.25a21.91,21.91,0,0,1-5.91,1.36,31.49,31.49,0,0,1-4.41,2.16,7.5,7.5,0,0,1-6.6-.1c-1.76-.94-7.05-1.39-7.05-1.39l1.6-.93A1.53,1.53,0,0,1,285.9,170.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.78,170.42l4.31-.26a21.91,21.91,0,0,1-5.91,1.36l-.21.13a32.59,32.59,0,0,1-3.33,1.65c-.27.13-.56.25-.87.38a8.51,8.51,0,0,1-3.38.7,6.87,6.87,0,0,1-3.22-.8,13,13,0,0,0-3.29-.91l-.61-.1h0l-.45-.06-1-.13-1.74-.19,1.6-.93a1.53,1.53,0,0,1,1.18-1.11,12.09,12.09,0,0,1,3.31.29,6.68,6.68,0,0,0,1.42.14c.85-.1,6.07-.45,6-.44h.05a11.84,11.84,0,0,0,3.42-.11,17.5,17.5,0,0,1,1.64-.65h0a40.07,40.07,0,0,1,5.56-1.44Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.22,170.44a2.57,2.57,0,0,0-1.43.62c-.27.42-.43,1.22-.91,1.61l-.61-.1h0l-.46-.06-.95-.13a3.49,3.49,0,0,1-.14-1.12,1.55,1.55,0,0,1,1.18-1.11A12.19,12.19,0,0,1,289.22,170.44Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.78,170.41l4.31-.25a21.91,21.91,0,0,1-5.91,1.36,28.14,28.14,0,0,1-3.53,1.79c-.54-.17.76-.86,1.3-1.28.69-.55.59-.44.27-.59s0-.26.83-.63.6-.53,1.07-1a2.3,2.3,0,0,1,.62-.39h0a40.07,40.07,0,0,1,5.56-1.44Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.72 171.26 285.27 171.51 285.14 172.41 283.12 172.19 284.72 171.26",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,171.65a32.59,32.59,0,0,1-3.33,1.65c-.27.13-.56.25-.87.38a8.51,8.51,0,0,1-3.38.7,8.37,8.37,0,0,1-1.54-2.19s.31-.93,1.92-1.51C294.84,170.31,298.55,171.07,301,171.65Z",
    style: {
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.88,170.62c2-1.06,13.54,3.55,18.28,3.76a27,27,0,0,1-9.83,1.17C295,175.14,289.75,171.73,291.88,170.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,174.38a27,27,0,0,1-9.83,1.17c-5.28-.41-10.58-3.82-8.45-4.93a5.28,5.28,0,0,1,2.81.06C299,171.49,306.54,174.22,310.16,174.38Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,174.38s-4,.69-4.64.42a4.63,4.63,0,0,0-2.44-.24c-1.13.1-1.68-.15-1.71-.8s-1.52-.13-2.55-.24,0-.41-.17-.85-2.09-.28-2.33-.63.54-.34,0-.66-2-.29-1.63-.7C299,171.49,306.54,174.22,310.16,174.38Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.78,294.47c0,2,20.49,5.39,20.81,5.39s4.31-.69,4.31-.69l7.29.69a2.78,2.78,0,0,0,.54-.77,5.3,5.3,0,0,0,.51-1.94c0-.2,0-.41,0-.64a18.82,18.82,0,0,0-.66-4.73,11.21,11.21,0,0,1-8.33-2.68c-1.06-2.62-2.5-5.47-4.08-6.7,0,0-14.4,1-17.41,2.74l0,0C138.8,286.89,138.78,294.47,138.78,294.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.78,294.47c0,2,20.49,5.39,20.81,5.39s4.31-.69,4.31-.69l7.29.69a2.78,2.78,0,0,0,.54-.77,5.3,5.3,0,0,0,.51-1.94c0-.2,0-.41,0-.64a18.82,18.82,0,0,0-.66-4.73,11.21,11.21,0,0,1-8.33-2.68c-1.06-2.62-2.5-5.47-4.08-6.7,0,0-14.4,1-17.41,2.74l0,0C138.8,286.89,138.78,294.47,138.78,294.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M146.46,294.82S158,270.26,203,233.94c0,0,96.74-13.19,160.14.15,0,0,25.51,35.07,28.29,52.62S146.46,294.82,146.46,294.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.59,233c.76,5.83,2.34,21.17,2.7,50.71-35.86,3.64-63.38,8.06-63.38,8.06,8.34-31.87,30.78-56.35,30.78-56.35A226.74,226.74,0,0,1,327.59,233Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.41,279.5c-5.65.23-11.32.52-16.94.88l-1.32.08-2.48.17-1.18.07c-10.53.71-20.89,1.6-30.7,2.56-.38-12.26-1.3-35-3.33-50.28a177.84,177.84,0,0,1,30.43,2.39l.33.06a.21.21,0,0,1,0,.06c.28.34.56.7.84,1l.32.42C377.91,255.55,387.41,279.5,387.41,279.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.31,287.5s36.39-7,106.11,0c0,0,14.05-31.57,32.59-52.07,0,0-45.09-6.82-88.28,0A307.8,307.8,0,0,0,152.31,287.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.88,232.4s-39-2.09-60.52-.14-25.26,10.79-25.26,10.79a108.08,108.08,0,0,1,17.71-5.33c0,1.9.08,4.75.86,5.86.59.83,9.64-.29,11.49-1.32,1.25-.7,2.84-4.16,3.74-6.34C245,234.42,277.88,232.4,277.88,232.4Zm-56.6,8.44c-.73.3-7.5,1.59-9.3,1.28-.52-.09-.61-2.59-.59-4.69,1.07-.19,2.15-.36,3.22-.49,2-.23,5.23-.53,9.29-.86C223,238.2,221.92,240.57,221.28,240.84Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.24,270.61a10.78,10.78,0,0,0-6.07-5.17s1.78-11.44,0-13.21-17.28-1.29-20.76,0c-2.51.92-4.33,7.12-5.15,10.51H293.82c.41-3.5.87-9.29-.35-10.51-1.78-1.78-17.29-1.29-20.77,0S267.06,265,267.06,265a17.65,17.65,0,0,0-7.65,3.52c-4,3-7.51,32.48-7.51,32.48H374.1S377.13,274.53,375.24,270.61Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.4,299.17s3.56-29.45,7.5-32.48a17.66,17.66,0,0,1,7.66-3.53s2.16-11.43,5.64-12.72,19-1.77,20.76,0,0,13.21,0,13.21a10.74,10.74,0,0,1,6.06,5.17c1.9,3.93-1.13,30.35-1.13,30.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.4,299.17s3.56-29.45,7.5-32.48a17.66,17.66,0,0,1,7.66-3.53s2.16-11.43,5.64-12.72,19-1.77,20.76,0,0,13.21,0,13.21a10.74,10.74,0,0,1,6.06,5.17c1.9,3.93-1.13,30.35-1.13,30.35Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.23,280a23.77,23.77,0,0,1-2.22-1.24c-.69-.44-1.38-.88-2-1.38a26.9,26.9,0,0,1-3.77-3.44,14.46,14.46,0,0,1-2.89-4.88,12.36,12.36,0,0,1-.37-1.54l-.17-1.36c-.05-.83-.09-1.66-.08-2.44a79.39,79.39,0,0,1,.63-9.09c.34-3,.76-5.92,1.34-8.88a1.71,1.71,0,0,1,3.39.3l.2,8.81c.1,2.91.14,5.85.39,8.62a10.66,10.66,0,0,0,.62,3.39,9.26,9.26,0,0,0,1.89,2.52,19.76,19.76,0,0,0,2.89,2.39c.54.37,1.07.75,1.64,1.09s1.17.71,1.62,1l.13.08a3.44,3.44,0,0,1-3.2,6.09Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,241.22l.54,1.61a2,2,0,0,1-.27,1.79L217.51,247a3.68,3.68,0,0,1-3,1.52h-.73c-1.09-2.61-.34-6.22-.34-6.22l.1-1.05a1.65,1.65,0,0,1,1.77-1.53l2.09.17A1.9,1.9,0,0,1,219,241.22Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.73,272.48s-7.94-4.47-8.83-5.79-1.29-11.49-1.29-11.49L211.4,258s-1.05,9,0,12.53,9,11.88,9,11.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.82,248.8c-4.76,3.88-4.2,15,1.15,22.37,0,0,11.41,1,17.75-1.88s-.67-20.91-7.37-22.34A16,16,0,0,0,228.82,248.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.09,260.4c-1.74-3-3.47-11.11,3.78-13.62,9-3.12,13.1,2.64,13.88,8.36s-2.44,10-8.42,9.61S230.3,262.48,229.09,260.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.38,283.26c-.88,4.18.67,14,.92,21.46l21.31,2.46a46.3,46.3,0,0,1,1.82-11.08c.8-3.14,1.94-7,3.51-11.67.23-.7.46-1.41.72-2.15a5.31,5.31,0,0,0-4.16-7.12c-.89-.14-1.85-.26-2.82-.36-3.79-.38-5.9-1.19-9.29-1.06-1.12,0-3.38-1-4.51-.87C222.85,273.21,220.21,279.34,219.38,283.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.57,263.16c-1.07,3.27-2.49,9.28-.46,11.61,0,0-3.11-.64-10,3.13-1.78-2.87-.3-3.68-.3-3.68,3.81-.68,4.07-3.42,3.75-6Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.71,265.22l-4.15,3a10.41,10.41,0,0,1,.09,1.84c1.44-.13,3.57-1.57,3.91-3A4.85,4.85,0,0,0,237.71,265.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,255.53c.07,5.46.22,7.76-2.32,10.75-3.81,4.5-10.52,3.4-12.22-1.92-1.53-4.79-1.39-12.9,3.76-15.46A7.44,7.44,0,0,1,242,255.53Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.37,250.43c-1.51,1.9,1.94,7.87,4.65,8.88C247.29,257.58,241.88,244.78,237.37,250.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.92,247.89c-2,.89-3.89,4.66-4.14,6.06,3,.23,10.67-3.22,10.67-3.22s5.41,1,2.5-1.45S230.92,247.89,230.92,247.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.93,257.75c0,.44-.18.82-.46.84s-.55-.32-.59-.76.18-.82.47-.84S232.9,257.31,232.93,257.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.93,258.13c0,.44-.17.81-.46.84s-.55-.32-.58-.76.17-.82.46-.84S227.9,257.69,227.93,258.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.48,257.38l-1.08-.23S227,257.94,227.48,257.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.05,258.68a12,12,0,0,1-1.36,2.94,1.92,1.92,0,0,0,1.6.18Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.83,263.35a4.43,4.43,0,0,1-.65.09.13.13,0,0,1-.14-.12.13.13,0,0,1,.12-.14,3.48,3.48,0,0,0,2.75-1.58.13.13,0,0,1,.23.13A3.68,3.68,0,0,1,232.83,263.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.84,260.4a4,4,0,0,1-1.91,2.38c-1.23.66-2.15-.37-2.06-1.69s.81-3,2.16-3.09A1.8,1.8,0,0,1,243.84,260.4Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.38,256.46a.28.28,0,0,1-.29-.12,3.07,3.07,0,0,0-2.18-1.16.26.26,0,1,1,0-.52,3.59,3.59,0,0,1,2.59,1.41.26.26,0,0,1-.09.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.78,255.8a.26.26,0,0,1-.25-.07.27.27,0,0,1,0-.37,2.56,2.56,0,0,1,2.26-.72.26.26,0,1,1-.12.5h0a2.09,2.09,0,0,0-1.78.6A.34.34,0,0,1,226.78,255.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.48,257l-1.09-.23S232,257.57,232.48,257Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.22,287.27c1.37,4,4.86,7.05,8.21,8.83.8-3.14,1.94-7,3.51-11.67-2.11-2.94-5.05-5-8.79-4.46C238.15,280,233.83,283.18,235.22,287.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.86,305.54c-.26,2.64,3.28,11,3.28,11h-2.82s-1.73-5.2-3.47-11.4c-.75-2.63-1.49-5.45-2.1-8.13-.29-1.25-.55-2.47-.77-3.62s-.43-2.49-.55-3.57a20.59,20.59,0,0,1,.69-8,19.92,19.92,0,0,1,3.56-7l-.56,0c5.33-.06,8.2,1.79,8.57,5.11a31.05,31.05,0,0,1-1.1,6.77c-1.54,6.6-4.14,15.71-4.65,18.4A4.43,4.43,0,0,0,242.86,305.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.69,272.87s-6.39,10.41-7.9,14.19-.65,14.6-.65,14.6-2.88-13-1-19.47S224.27,270.53,228.69,272.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.59,286.65c-1.54,6.6-4.14,15.71-4.65,18.4-1.08.05-2.15.08-3.09.09-.75-2.63-1.49-5.45-2.1-8.13-.29-1.25-.55-2.47-.77-3.62,1.32-.52,3.13-1.25,3.83-1.61,1.14-.57.75-11.26.75-11.26A17.49,17.49,0,0,1,247.59,286.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.4,301l1.53.73a1.94,1.94,0,0,0,1.8-.05l2.61-1.44a3.69,3.69,0,0,0,1.87-2.81l.08-.73c-2.45-1.39-6.12-1.08-6.12-1.08l-1.06,0a1.65,1.65,0,0,0-1.73,1.57l-.08,2.09A1.89,1.89,0,0,0,221.4,301Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.65,279.75a51.93,51.93,0,0,1,1.32,9.07,25.8,25.8,0,0,1-.15,4.92,11.2,11.2,0,0,1-.77,2.93,7.07,7.07,0,0,1-1.13,1.79,4.88,4.88,0,0,1-1,.89,4.46,4.46,0,0,1-.63.35l-.36.15a16.66,16.66,0,0,1-5.15.92,37.06,37.06,0,0,1-4.62-.12,55.82,55.82,0,0,1-8.82-1.48,1.71,1.71,0,0,1,.39-3.37h.06c1.39,0,2.83,0,4.23-.09s2.81-.09,4.19-.2,2.73-.24,4-.44a12.43,12.43,0,0,0,3.26-.9l.13-.07-.16.08a1.16,1.16,0,0,0-.24.17c-.09.08-.07.05,0-.06a6.38,6.38,0,0,0,.19-1.27,26.47,26.47,0,0,0-.12-3.71c-.12-1.31-.32-2.66-.54-4s-.47-2.74-.71-4l0-.11a3.44,3.44,0,0,1,6.73-1.42Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.54,276.42c2.8-.93,5,2.22,5.9,7.75s1.06,14.14-2,15.74-8.66,1.32-8.66,1.32l-3.24-6.29s5.75-1,6.28-1.8-.68-8.45-1.13-10.75S241.5,277.43,244.54,276.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.61,299.17s3.56-29.45,7.5-32.48a17.66,17.66,0,0,1,7.66-3.53s2.16-11.43,5.64-12.72,19-1.77,20.76,0,0,13.21,0,13.21a10.74,10.74,0,0,1,6.06,5.17c1.9,3.93-1.13,30.35-1.13,30.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.61,299.17s3.56-29.45,7.5-32.48a17.66,17.66,0,0,1,7.66-3.53s2.16-11.43,5.64-12.72,19-1.77,20.76,0,0,13.21,0,13.21a10.74,10.74,0,0,1,6.06,5.17c1.9,3.93-1.13,30.35-1.13,30.35Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,275a54.85,54.85,0,0,1-4.67,9.32c-2.18,3.33-4.18,6.24-7.93,8.49-6.42,3.27-15.3.69-21.66-1.55l1-4.13c4.55.28,9.28.62,13.71,0,3-.48,3.5-1.27,5.29-3.54a69.48,69.48,0,0,0,6.29-11.76l8,3.16Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.15,268.26c-2.45.56-4.95,3.72-12.32,16.69,0,0-1.14,1.56-6.06,2.09l-.37,7.69s6.9.43,8.61-.51S288,278.58,288,278.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.77,287l-.37,7.68s5.53.35,7.92-.25a2.72,2.72,0,0,0,.69-.25c1-.54,5.17-5.69,8.52-9.94,2.43-3.09,4.42-5.7,4.42-5.7l-2.8-10.32c-2.44.56-4.95,3.72-12.32,16.69C272.83,285,271.69,286.51,266.77,287Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.32,294.47a2.72,2.72,0,0,0,.69-.25c1-.54,5.17-5.69,8.52-9.94a77.45,77.45,0,0,0-1.83-7.89S275,286.79,274.32,294.47Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.36,287.67l-5.16-2.51-.11,7.26s4.86,1.15,5.74-1.38Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.6 286.14 247.79 292.15 252.09 292.42 252.2 285.16 247.6 286.14",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.77 286.71 263.94 287.24 264.15 294.77 266.84 295.54 266.77 286.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.69,313l-30.91-3.28a1.56,1.56,0,0,1-1.38-1.5c-.64-30.32,7.75-39.91,7.75-39.91a55.81,55.81,0,0,1,8.66-.83,108.7,108.7,0,0,1,12.6,1.07,58,58,0,0,1,8.46,1.75c1.47.81,2.28,7.65-1.45,28.26-1,5.4-1.53,10.1-1.79,12.85A1.76,1.76,0,0,1,309.69,313Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.36 279.31 282.4 278.68 281.19 285.74 284.17 288.15 287.55 286.91 288.36 279.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.4,308.17a1.54,1.54,0,0,0,1.38,1.49L309.69,313a1.76,1.76,0,0,0,1.94-1.59c.26-2.75.82-7.45,1.79-12.85q.81-4.44,1.33-8.06a111.15,111.15,0,0,0,1.34-13.27c.1-4.55-.47-6.51-1.21-6.93a58.41,58.41,0,0,0-8.47-1.75,110.75,110.75,0,0,0-12.6-1.07,57.06,57.06,0,0,0-8.66.83S276.76,277.85,277.4,308.17Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.17,268.16l-10.35,2.35-.11-2.91a4.56,4.56,0,0,0,.91-4.72l7.48-7C303.5,259.83,303.65,265.27,306.17,268.16Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.33,272.38l-2.05.6-1.82.9s-3.67,12.82-4.2,23.92l-2.09,1.37-1.85-1.84s4.67-20,6-23.85l-.29-1-.72-2.07,1.8-.7,2.64.87,1.88.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05,258.76l-4.42,4.12a13.93,13.93,0,0,1,.48,2.22c1.72-.32,4-2.33,4.13-4.15A6,6,0,0,0,301.05,258.76Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.74,266.28a47.65,47.65,0,0,1-9.5,3.72,9,9,0,0,1,.45-4.24l-4.64,1.73s-.73,3.39.09,5.27l3.49-2,3.33,3.34s7.17-1.92,8.63-5.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.29,279.31l-2.77,8.39c17.21,14,32,8.46,35.23,2.75a111.15,111.15,0,0,0,1.34-13.27c-3.5-.54-6.68-3.19-8-2.41-2.22,1.36-10,5.2-13.7,5.69C291.4,280.87,282.29,279.31,282.29,279.31Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.4,245.08c-.91,2.1-1,6.59,2.18,5.46S291,241.48,289.4,245.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.72,249.63c-.24,5.61-.1,8.91-2.89,11.8-4.18,4.37-11.16,1.86-12.6-3.73-1.29-5-.68-13.35,4.78-15.62A7.74,7.74,0,0,1,304.72,249.63Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.71,244.34l-6-1.75-1,3.45.4-.11s-.85,5.17,1.63,7.62C308.4,251.5,310.74,246.88,308.71,244.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,254.26a5.26,5.26,0,0,1-2.57,3.14c-1.66.86-2.89-.54-2.76-2.31.11-1.59,1.11-4,2.94-4.08A2.42,2.42,0,0,1,307,254.26Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.23,251.27c0,.45-.22.82-.52.83s-.55-.37-.56-.83.23-.82.53-.83S296.22,250.81,296.23,251.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.07,251.31c0,.45-.23.83-.53.83s-.55-.37-.56-.82.23-.83.53-.83S291.06,250.85,291.07,251.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.71,251.52a15.8,15.8,0,0,1-2.15,3.78,2.69,2.69,0,0,0,2.18.35Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.22,257.38a3.81,3.81,0,0,1-.59,0,.13.13,0,0,1-.14-.13.13.13,0,0,1,.13-.13,3.6,3.6,0,0,0,2.93-1.44.13.13,0,0,1,.18,0,.12.12,0,0,1,0,.18A3.69,3.69,0,0,1,295.22,257.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.8,249.59a.29.29,0,0,1-.26-.1,2.17,2.17,0,0,0-1.73-.89.27.27,0,0,1-.05-.53,2.7,2.7,0,0,1,2.21,1.09.26.26,0,0,1-.05.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.81,249.55a.3.3,0,0,1-.16,0,.28.28,0,0,1-.13-.36,2.62,2.62,0,0,1,1.91-1.52.27.27,0,0,1,.07.53A2,2,0,0,0,289,249.4.25.25,0,0,1,288.81,249.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.66,247.69a2,2,0,0,1-.42.16,2.49,2.49,0,0,1-2.37-.47c-1.33-1.11-.76-5.51-5.58-4.37a2.59,2.59,0,0,0-2.8.29c-1.43,1.08-1.87,6.21-4.06,4.95s-1.6-1.88-1.6-1.88.56.58,1,.34a2.27,2.27,0,0,1-.05-2.61s.41.81.83.77a10.23,10.23,0,0,1,2.09-5.77c2.19-3.08,10.37-.29,10.37-.29s1.49-1.5,5,.64,4.1,7.12,3,9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.1,304.24a15,15,0,0,1-5.11-.92,16.6,16.6,0,0,1-10.13-19.87,14.17,14.17,0,0,1,18.74-9.55,16.6,16.6,0,0,1,10.13,19.87,14.29,14.29,0,0,1-7.25,8.94A14,14,0,0,1,258.1,304.24Zm-1.6-28.38a11.15,11.15,0,0,0-5.09,1.21,11.46,11.46,0,0,0-5.79,7.17A13.73,13.73,0,0,0,254,300.62,11.29,11.29,0,0,0,269,293a13.71,13.71,0,0,0-8.34-16.38A11.92,11.92,0,0,0,256.5,275.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.36,284.14a65,65,0,0,1-13.68,6.64c-3.15,1.11-6.31.27-9.27-.51a95.19,95.19,0,0,1-20.26-9.17l1.82-3.84c3.34,1.16,6.75,2.3,10.11,3.35,4.62,1.34,9.78,3.17,14.34,3.07.64-.1.1,0,1.19-.5l2.25-1.2c3-1.65,6.05-3.45,9-5.13l4.5,7.29Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.11,277.18,266.49,276l1.68,7.07s5-.08,5.23-2.74Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.28 278.09 263.93 283.87 268.17 283.08 266.49 276.01 262.28 278.09",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.88,270.25c6.57,4.45,2.39,11.64,0,15.18s-17.8,8.14-20.45,7.86-14.91-6.11-14.91-6.11l3.09-7.3s8.44,2.39,11.2,2.71S314.88,270.25,314.88,270.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.88,270.25c6.57,4.45,2.39,11.64,0,15.18s-17.8,8.14-20.45,7.86-14.91-6.11-14.91-6.11l3.09-7.3s8.44,2.39,11.2,2.71S314.88,270.25,314.88,270.25Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.15 279.5 280.25 288.49 277.88 286.96 280.44 278.91 283.15 279.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.32,300.57c-3.08-7.59-13.7-17.94-17-20.69s-12.07-3.79-27.35-3.34a33.54,33.54,0,0,0-14.46,4c-11.78.09-31.16.34-39.08,1-5.85.51-21.21,2.14-22.54,7.76s7.2,19.06,8,19.06h43.66a7.15,7.15,0,0,0,.42,2.1c.63.52,49.38,4.15,49.38,4.15S277.4,308.17,274.32,300.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.32,300.57c-3.08-7.59-13.7-17.94-17-20.69s-12.07-3.79-27.35-3.34a33.54,33.54,0,0,0-14.46,4c-11.78.09-31.16.34-39.08,1-5.85.51-21.21,2.14-22.54,7.76s7.2,19.06,8,19.06h43.66a7.15,7.15,0,0,0,.42,2.1c.63.52,49.38,4.15,49.38,4.15S277.4,308.17,274.32,300.57Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.41,279.49c-5.65.23-11.32.53-16.94.88l-1.32.09-2.48.16-1.18.08c-7.8.53-15.5,1.15-23,1.83,7.47-18.78,12.59-35.26,13-36.55-4.44,10.82-14.62,21.45-14.62,21.45a221.83,221.83,0,0,0,12.92-33.22c4.36.5,7.17,1,8.08,1.16l.33.06a.21.21,0,0,1,0,.06q.42.51.84,1l.32.42C377.91,255.55,387.41,279.49,387.41,279.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.8,263.14c14.78-8.64,28.76-15.84,30-16.5-15.78,8.87-33.84,25.73-46,38.1-19.53.83-29.52,2.76-29.52,2.76a308.06,308.06,0,0,1,50.43-52.07,274.45,274.45,0,0,1,43.23-3C220.61,243.5,198.64,262.42,197.8,263.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.63,345.67H276.3c-14.82,0-26.83,16.6-26.83,37.08s12,37.08,26.83,37.08h13.33c14.82,0,26.83-16.6,26.83-37.08S304.45,345.67,289.63,345.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.83,
    cy: 382.75,
    rx: 22.42,
    ry: 34.45,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.77,364.13c-6.69,0-12.11,8.34-12.11,18.62s5.42,18.62,12.11,18.62,12.12-8.34,12.12-18.62S302.46,364.13,295.77,364.13Z",
    style: {
      fill: "#263238",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.16,345.67H122.83C108,345.67,96,362.27,96,382.75s12,37.08,26.83,37.08h13.33c14.82,0,26.84-16.6,26.84-37.08S151,345.67,136.16,345.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.36,
    cy: 382.75,
    rx: 22.42,
    ry: 34.45,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.31,
    cy: 382.75,
    rx: 12.11,
    ry: 18.62,
    style: {
      fill: "#263238",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.78,342.55l.19,38.16a11,11,0,0,1-11,11.08H302.69a43.52,43.52,0,0,1-31,13H209.43l-7.08-10.62H188.18l-1.88,1.78A28.08,28.08,0,0,1,167,403.59h0A28.06,28.06,0,0,1,146.85,395l-.85-.89H113.62A11,11,0,0,1,102.78,385l-8.65-49.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.67,335.33l-5.19-3.82c-4.72-29.83-11.48-43-11.48-43l-11.72-10c-4.51-16.27-20.84-43.58-29.42-46.73h-.05c-1.39-.36-32.75-7-81.79-7-61.38,0-79,10.29-79,10.29-24.38,17.94-52.28,52.72-52.28,52.72A126.17,126.17,0,0,0,108,311.51c-1.31,1.17-2.61,2.4-3.88,3.67-1.09,1.08-2.17,2.2-3.21,3.36-.8.88-1.59,1.78-2.36,2.7a58,58,0,0,0-7,10.73,82.1,82.1,0,0,0-3.44,7.7c-.38,1-.71,1.91-1,2.8-.19.55-4.75,5.83-4.75,5.83-2.65,1.44.86,22.83,5.63,33.88a4.11,4.11,0,0,0,3.78,2.46H219.2c.22-25.92,15.58-46.83,34.51-46.83s34.27,20.91,34.5,46.83h58.48c.22-25.92,15.58-46.83,34.51-46.83a26.09,26.09,0,0,1,10.91,2.43c12.84,5.87,22.32,21.82,23.47,41,0,.31,0,.64.06.95a6.74,6.74,0,0,0,.89-1.16h0a3.54,3.54,0,0,0,1.82-2.2C423.26,365.51,418.67,335.33,418.67,335.33ZM152.3,287.49a308.69,308.69,0,0,1,50.43-52.06c43.19-6.83,88.28,0,88.28,0-18.54,20.5-32.59,52.06-32.59,52.06C188.7,280.46,152.3,287.49,152.3,287.49Zm114.61,4.29c8.34-31.87,30.78-56.35,30.78-56.35a226.74,226.74,0,0,1,29.9-2.42c.76,5.83,2.34,21.17,2.7,50.71C294.43,287.36,266.91,291.78,266.91,291.78Zm103.56-11.4-1.32.08-2.48.17-1.18.07c-10.53.71-20.89,1.6-30.7,2.56-.38-12.26-1.3-35-3.33-50.28a177.84,177.84,0,0,1,30.43,2.39l.33.06a.21.21,0,0,1,0,.06c.28.34.56.7.84,1l.32.42c14.49,18.59,24,42.54,24,42.54C381.76,279.73,376.09,280,370.47,280.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.22,345.67H240.88c-14.82,0-26.83,16.6-26.83,37.08s12,37.08,26.83,37.08h13.34c14.81,0,26.83-16.6,26.83-37.08S269,345.67,254.22,345.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 258.42,
    cy: 382.75,
    rx: 22.42,
    ry: 34.45,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.36,364.13c-6.69,0-12.12,8.34-12.12,18.62s5.43,18.62,12.12,18.62,12.11-8.34,12.11-18.62S267.05,364.13,260.36,364.13Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.35,345.67H366c-14.82,0-26.83,16.6-26.83,37.08s12,37.08,26.83,37.08h13.33c14.82,0,26.83-16.6,26.83-37.08S394.17,345.67,379.35,345.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.55,
    cy: 382.75,
    rx: 22.42,
    ry: 34.45,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 385.49,
    cy: 382.75,
    rx: 12.11,
    ry: 18.62,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.49,386.1l3.88-18.75a4,4,0,0,1,3.95-3.22h27.79a6.83,6.83,0,0,1,6.16,3.86l8.8,18.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.5,329.65l-18.83,11.86-40,8.61H104.47L87,342.47c.31-.89.64-1.82,1-2.8a82.1,82.1,0,0,1,3.44-7.7c.06-.12.12-.24.19-.36a57.71,57.71,0,0,1,6.85-10.37c.77-.92,1.56-1.82,2.36-2.7,8.07,2,10.77,11.11,10.77,11.11l1.48,14.16.43,4.11h45.38l2.84-4.09,9.88-14.18s13.62-7.2,25.13-9.46c9.17-1.8,26.65-2,26.65-2C228.5,320.18,229.5,329.65,229.5,329.65Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.39,332.87c-.45,3.56-3.1,6.15-5.92,5.8s-4.74-3.54-4.28-7.1,3.1-6.16,5.92-5.8S203.84,329.31,203.39,332.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.42,
    cy: 336.92,
    rx: 9.38,
    ry: 7.42,
    transform: "translate(-200.65 358.17) rotate(-64.88)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.8,
    cy: 336.92,
    rx: 9.38,
    ry: 7.42,
    transform: "translate(-245.33 287.89) rotate(-64.88)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,327.26a8.93,8.93,0,0,0-5,5.2,10,10,0,0,0-.72,3.76,1.06,1.06,0,0,1-.4-.08c-1.58-.64-1.79-3.84-.46-7.19s3.68-5.52,5.26-4.89C100.56,324.42,101,325.65,101,327.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.91,363.15l2.37.57a1.87,1.87,0,0,1,1.41,2.13l-2.09,12.62a1.87,1.87,0,0,1-1.85,1.56H173a1.88,1.88,0,0,1-1.88-1.87h0a1.88,1.88,0,0,1,1.53-1.85c3-.56,10.1-2.89,17.28-12.44A1.88,1.88,0,0,1,191.91,363.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.91 363.15 176.96 363.1 191.91 366.9 191.91 363.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,363.1l-11.16,1L90.42,381h8.74l-1.91-4.29a20.15,20.15,0,0,1-8.55-9.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.12,375.39c0,2.11-1.4,3.82-3.13,3.82s-3.12-1.71-3.12-3.82,1.4-3.82,3.12-3.82S192.12,373.28,192.12,375.39Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.45,375.48c.57,2,.27,3.89-.67,4.15s-2.16-1.17-2.73-3.21-.27-3.89.67-4.15S92.89,373.44,93.45,375.48Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.19,335.33h-7.66a.94.94,0,0,0-.89,1.23l2.23,6.95a.94.94,0,0,0,1.64.29l5.42-6.95A.94.94,0,0,0,137.19,335.33ZM134.86,337l-2.71,3.48a.47.47,0,0,1-.82-.15l-1.12-3.47a.48.48,0,0,1,.45-.62h3.83A.47.47,0,0,1,134.86,337Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.5,329.65l-18.83,11.86-40,8.61H104.47L87,342.47c.31-.89.64-1.82,1-2.8a81.25,81.25,0,0,1,3.62-8.06h0L90.26,340a3.29,3.29,0,0,0,1.9,3.53l10,4.47a5.26,5.26,0,0,0,5-.36l6-3.86.43,4.11h45.38l2.84-4.09,6.32,4.24a4.73,4.73,0,0,0,3.62.71l35.58-7.54A6.29,6.29,0,0,0,212,337l2.07-6.71a4.73,4.73,0,0,0-1.63-5.13l-5.12-4c9.17-1.8,16.11-3,16.11-3C228.5,320.18,229.5,329.65,229.5,329.65Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.13 343.81 115.02 343.81 115.39 346.82 157.07 346.82 159.15 343.81 161.78 343.83 158.94 347.92 113.56 347.92 113.13 343.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.42 350.12 113.13 348.9 159.15 348.9 160.2 350.12 111.42 350.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.67,335.33l-5.19-3.82a238.67,238.67,0,0,0-5.13-24.64c-3.06-11.41-5.78-17.24-6.27-18.25a.91.91,0,0,0-.08-.15l-11.72-10c-4.51-16.28-20.84-43.58-29.42-46.73h-.05c-46.05-5.9-65,1.21-65,1.21-24.11,29.4-34,58.8-34,58.8a241.68,241.68,0,0,0-38.32,26.37c1,9.22-5.49,18.77-5.49,18.77l-7.28,4.59.77,10.61c-4.55,14.39-11.74,32.51-11.74,32.51h19.5c.22-25.91,15.58-46.82,34.51-46.82s34.27,20.91,34.5,46.82h58.48c.22-25.91,15.58-46.82,34.51-46.82a26.08,26.08,0,0,1,10.91,2.42c12.84,5.87,22.32,21.83,23.47,41,0,.32,0,.64.06,1a6.81,6.81,0,0,0,.89-1.17h0a3.49,3.49,0,0,0,1.82-2.19C423.26,365.51,418.67,335.33,418.67,335.33ZM266.91,291.78c8.34-31.87,30.78-56.35,30.78-56.35a228.6,228.6,0,0,1,29.9-2.43c.76,5.84,2.34,21.18,2.7,50.72C294.43,287.36,266.91,291.78,266.91,291.78Zm103.56-11.41-1.32.09-2.48.16-1.18.08c-10.53.71-20.89,1.6-30.7,2.56-.38-12.26-1.3-35.06-3.33-50.28a176.69,176.69,0,0,1,30.43,2.39l.33.06a.21.21,0,0,1,0,.06q.42.51.84,1l.32.42c14.49,18.59,24,42.53,24,42.53C381.76,279.72,376.09,280,370.47,280.37Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.47,280.38l-1.32.08c-3.11-25.46-5.69-38.62-7.26-45.09l.33.06a.21.21,0,0,1,0,.06c.28.34.56.7.84,1C367,253.82,369.29,270.52,370.47,280.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.92,384.63h9.13a8.65,8.65,0,0,0,8.44-6.65c2.37-10,9.31-28.35,28.73-32.31,20.46-4.17,27.22,20.2,29.31,32.36a7.93,7.93,0,0,0,7.81,6.6h2.19s0-59.38-42.8-54.72C220.53,333.21,212,378.2,212,378.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.92,384.63h9.13a8.65,8.65,0,0,0,8.44-6.65c2.37-10,9.31-28.35,28.73-32.31,20.46-4.17,27.22,20.2,29.31,32.36a7.93,7.93,0,0,0,7.81,6.6h2.19s0-59.38-42.8-54.72C220.53,333.21,212,378.2,212,378.2Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.05,384.63h9.14a8.65,8.65,0,0,0,8.43-6.65c2.38-10,9.32-28.35,28.73-32.31,20.46-4.17,27.23,20.2,29.32,32.36a7.91,7.91,0,0,0,7.81,6.6h2.19s0-59.38-42.81-54.72c-30.19,3.3-38.73,48.29-38.73,48.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.05,384.63h9.14a8.65,8.65,0,0,0,8.43-6.65c2.38-10,9.32-28.35,28.73-32.31,20.46-4.17,27.23,20.2,29.32,32.36a7.91,7.91,0,0,0,7.81,6.6h2.19s0-59.38-42.81-54.72c-30.19,3.3-38.73,48.29-38.73,48.29Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.21,329.71c5.29-.43,10.62,1.33,15.17,4.1a38.16,38.16,0,0,1,11.36,11.24,63.58,63.58,0,0,1,7.08,14.37,105.21,105.21,0,0,1,4,15.46l-1.32-1.1,22.83-.1,22.83.08-1.33,1.06a91.9,91.9,0,0,1,5.5-15.49,73.32,73.32,0,0,1,8.41-14.09,44.09,44.09,0,0,1,12.1-11,35.27,35.27,0,0,1,7.5-3.3,32.75,32.75,0,0,1,8-1.23,37.27,37.27,0,0,0-7.85,1.79,34.52,34.52,0,0,0-7.1,3.65,45.4,45.4,0,0,0-11.17,11.25,73.53,73.53,0,0,0-7.72,13.95,90.46,90.46,0,0,0-5.05,15.1l-.25,1.06h-1.07l-22.83.08-22.83-.1H292.4l-.18-1.1a108.74,108.74,0,0,0-3.63-15.17,64.69,64.69,0,0,0-6.38-14.13,38.94,38.94,0,0,0-10.41-11.36A26.27,26.27,0,0,0,257.21,329.71Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.44,352.12s28.13-26.14,55.47-20.2c0,0-12.65-6.48-37.41-2.27l-21.58,14.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,299.17S378.11,286.26,402,288.47l-9.42-8S282.5,288.34,269,299.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35,306.87c-5.24-9.74-10.74-12.49-10.74-12.49l-6.2-8.94a20.25,20.25,0,0,1,10.67,3.18C402.57,289.63,405.29,295.46,408.35,306.87Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.73,294.47c0,2-20.48,5.39-20.81,5.39s-4.31-.69-4.31-.69l-7.28.69a2.78,2.78,0,0,1-.54-.77,5.3,5.3,0,0,1-.51-1.94,6.4,6.4,0,0,1,0-.64,19.33,19.33,0,0,1,.66-4.73,11.22,11.22,0,0,0,8.34-2.68c1.06-2.62,2.5-5.47,4.08-6.7,0,0,14.4,1,17.41,2.74l0,0C299.72,286.89,299.73,294.47,299.73,294.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.73,294.47l-.78-.67s-22.44,4.55-22.62,0,3-11.4,3-11.4,14.49,1,17.44,2.76S299.73,294.47,299.73,294.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.73,294.47c0,2-20.48,5.39-20.81,5.39s-4.31-.69-4.31-.69l-7.28.69a2.78,2.78,0,0,1-.54-.77,5.3,5.3,0,0,1-.51-1.94l8.33-1.62,1.79-2.23a153.81,153.81,0,0,0,18-1.28,1.49,1.49,0,0,0,1.27-1.5c0-1.21,0-3,0-3.82a2.53,2.53,0,0,1,1-1.56l0,0C299.72,286.89,299.73,294.47,299.73,294.47Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardrivingRafiki2);
export default __webpack_public_path__ + "static/media/Car driving-rafiki (2).73798b83ffb9553bcbe9902d18f73d23.svg";
export { ForwardRef as ReactComponent };